import borders from "@/themes/base/borders";
import boxShadows from "@/themes/base/boxShadows";
import colors from "@/themes/base/colors";
import pxToRem from "@/themes/functions/pxToRem";

const { transparent } = colors;
const { lg } = boxShadows;
const { borderRadius } = borders;

const popover = {
  styleOverrides: {
    paper: {
      backgroundColor: transparent.main,
      boxShadow: lg,
      padding: pxToRem(8),
      borderRadius: borderRadius.md,
    },
  },
};

export default popover;
